<template>
    <div class="content">

        <el-dialog title="Documents" :visible.sync="dialogTabledocuments">
                        <el-upload id='uploadDocs' list-type="picture-card"  ref="upload"
                            :on-remove="handleRemove"
                            :file-list="fileList" 
                            :on-preview="handlePreview"
                            :on-change='handleSuccess'
                             multiple>
                        <el-button size="small" type="primary" >Ajouter un document</el-button>
                        </el-upload>
                <a href="#" class="download-link"></a>
                <el-dialog class="dialog_IMG" :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
        </el-dialog>

        <el-dialog title="Compte Rendu" :visible.sync="dialogCompteRendu" @closed="handleTextarea('tt')" style="left:-100px;width:125%;" top="5%">
            <el-tabs type="card">
                
                <el-tab-pane label="Préparation">
                    <ckeditor ref='commentPrep' :editor="editor" v-model="commentPrep" :config="editorConfig" id='inputCommentPrep'></ckeditor>
                </el-tab-pane>

                <el-tab-pane label="Compte rendu">
                    <ckeditor ref='commentCompteRend' :editor="editor" v-model="commentCompteRend" :config="editorConfig"  id='inputCommentCompteRend'></ckeditor>
                </el-tab-pane>
            
            </el-tabs>  

        </el-dialog>

        <div class="el-table__header-wrapper" style="margin-top:-3px;height: 60px;background-color: #33434a;">
        <label style="color:white;font-family: Segoe UI;font-size: 13px;font-weight: bold;margin-top:20px;">GESTION DES ACTIONS</label>
        </div>
        <br>
                     
                <el-row id='first-row' v-if=!is_projet_client>
                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >

                            <span style="margin-left:18px;">
                            Client<abbr style="color:red">*</abbr> : 
                            </span>  
                            <el-select id=CbClient :aria-required="true" style="margin-left:40px;width:355px"  v-model="nom_cli" size='mini' placeholder="" class="selectColDroite2" :disabled="insertH==0" filterable :filter-method="clientfilterHandler" @change='client_change'>
                                <el-option align="left"
                                  v-for="item in optionsNom_Cli"
                                  :key="item.CDE_CLI"
                                  :label="item.LABEL"
                                  :value="item.CDE_CLI">
                                </el-option>
                            </el-select>
                            
                        </el-col>
                    </el-row>


                     <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:18px">
                            Commercial<abbr style="color:red">*</abbr> : 
                            </span>
                            <el-select id=CbCommercial v-model="nom_com" size='mini' style="margin-left:3px;width:355px" placeholder="" class="selectColDroite2" :disabled="insertH==0 || superviseur==0" filterable @change='commercial_change'>
                                <el-option :key='null' :label='null' :value='null'></el-option>
                                <el-option align="left"
                                    v-for="item in listeCommercial" 
                                        :key="item.VENDEUR"
                                        :label="item.NOM"
                                        :value="item.VENDEUR">
                                </el-option>
                            </el-select>
        
                        </el-col>
                        
                    </el-row>

                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
 
                            <span style="margin-left:20px">
                            Auteur : 
                            </span>
  
                            <el-input style="margin-left:40px;width:355px"
                              size='mini'
                              v-model="auteur"
                              :disabled="true"
                             >
                            </el-input> 
                           
                            
                        </el-col>
                        
                    </el-row>
                    
                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >

                            <span style="margin-left:20px;">
                            Action : 
                            </span>
                            
                            <el-input style="margin-left:42px;width:128px"
                              size='mini'
                              v-model="numAct"
                              :disabled="true"
                              >
                            </el-input>   

                            <span style="margin-left:36px;">
                            Etat : 
                            </span>
                            
                            <el-input style="margin-left:2px;width:150px"
                              size='mini'
                              v-model="etat"
                              :disabled="true"
                              >
                            </el-input> 
                            
                        </el-col>
                    </el-row>


                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
       
                            <span style="margin-left:20px">
                            Objet<abbr style="color:red">*</abbr> : 
                            </span> 
                             <el-select id=Cbobjet :aria-required="true" v-model="objet" size='mini' style="margin-left:40px;width:355px" placeholder="" class="selectColDroite2" :disabled="etat=='Cloturé'" filterable :filter-method="objetfilterHandler" @change='handleUpdateObjet'>
                                <el-option align="left"
                                    v-for="item in optionsObjet" 
                                        :key="item.LIB_50"
                                        :label="item.LIB_50"
                                        :value="item.CDE_TABLE">
                                </el-option>
                            </el-select>

                        </el-col>
                        
                    </el-row>


                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
                           
                            <span style="margin-left:20px">
                            Priorité<abbr style="color:red">*</abbr> : 
                            </span>  

                            <el-select id=CbPriorite :aria-required="true" style="margin-left:27px;width:355px"  v-model="priorite" size='mini' placeholder="" class="selectColDroite2" @change='handleUpdatePriorite' :disabled="etat=='Cloturé'" >
                                <el-option :key='null' :label='null' :value='null'></el-option>
                                <el-option align="left"
                                 v-for="item in optionsPriorite" 
                                    :key="item.LIB_50" 
                                    :label="item.LIB_50"
                                    :value="item.CDE_TABLE">
                                </el-option>
                            </el-select>      
                             
                        </el-col>
                        
                    </el-row>


                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:20px">
                            Technicien : 
                            </span>

                            <el-select v-model="technicien" size='mini' placeholder="" class="selectColGauche" style="margin-left:14px;width:355px;"
                                    @change="handleSelectChange('TECHNICIEN')" :disabled="etat=='Cloturé'" filterable>
                                    <el-option align="left"
                                     v-for="item in listeTechniciens" 
                                        :key="item.RESSOURC" 
                                        :label="item.RES_LIB"
                                        :value="item.RESSOURC">
                                    </el-option>
                            </el-select>
                        </el-col></el-row> <el-row class="ligneAct"> <el-col class="ColonneGauche" >
                            <span style="margin-left:18px">
                            Prestataire
                            </span>
                            <el-select v-model="prestataire" size='mini' placeholder="" class="selectColGauche" style="margin-left:20px;width:355px;"
                                    @change="handleSelectChange('PRESTATAIRE')" :disabled="etat=='Cloturé'" filterable :filter-method="prestatairefilterHandler">
                                    <el-option align="left"
                                    v-for="item in listePrestataires" 
                                        :key="item.RESSOURC" 
                                        :label="item.RES_LIB"
                                        :value="item.RESSOURC">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row> 
                

                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >

                            <span style="margin-left:20px">
                            Créé(e) le<abbr style="color:red">*</abbr> :
                            </span>

                            <el-date-picker id= 'date_crt' style="margin-left:10px;width:130px;" size='mini' class="selectColDroite" v-model="dte_creat" type="date"
                                placeholder="Date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" :disabled="insertH==0">
                            </el-date-picker> 
                        </el-col>
                    </el-row>
                    


                     <el-row class="ligneAct" >
                        
                        <el-col class="ColonneGauche" >

                            <span style="margin-left:20px">
                            Prévu(e) le<abbr style="color:red">*</abbr> :
                            </span>

                            <el-date-picker id= 'date_pre' size='mini' v-model="dte_prev"  style="margin-left:3px;width:130px;"
                                class="selectColDroite" type="datetime" 
                                value-format="dd-MM-yyyy" format="dd-MM-yyyy" @change='handleDtePrev' 
                                :disabled="etat=='Cloturé'"
                                :aria-required="true"
                                :picker-options="datePickerOptions">
                            </el-date-picker>

                             <el-time-picker size='mini' v-model="dte_prevD" style="margin-left:10px;width:100px;"
                                class="selectColDroite" type="datetime"
                                value-format="HH:mm" format="HH:mm" @change='handleDtePrev' :disabled="etat=='Cloturé'">
                             </el-time-picker>

                             <span style="margin-left:10px">/</span>

                             <el-time-picker size='mini' v-model="dte_prevF" style="width:100px"
                                class="selectColDroite" type="datetime" placeholder="Date"
                                value-format="HH:mm" format="HH:mm" @change='handleDtePrev' :disabled="etat=='Cloturé'">
                             </el-time-picker> 
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche">

                            <span v-if="etat=='En cours' && !taches_clotures" style="font-style: italic;margin-left:20%">Action en cours. Veuillez clôturer vos tâches pour clôturer l'action</span>
                            <span style="margin-left:20px" v-if="insertH==0 && taches_clotures">
                            Réalisé(e) le :  
                            </span>
                            <el-date-picker size='mini' v-model="dte_real" id='detail_dte_real' style="margin-left:3px;width:130px"
                                    class="selectColDroite" type="datetime" placeholder="Date"
                                    value-format="dd-MM-yyyy" format="dd-MM-yyyy" @change='handleDteReal' v-if="insertH==0 && taches_clotures" :disabled="insertH==1 || etat=='Cloturé'"
                                    :picker-options="datePickerOptions">
                            </el-date-picker>

                             <el-time-picker size='mini' v-model="dte_real" style="margin-left:10px;width:100px;"
                                class="selectColDroite" type="datetime"
                                value-format="dd-MM-yyyy HH:mm" format="HH:mm" @change='handleDtePrev' :disabled="insertH==1 || etat=='Cloturé'"
                                v-if="insertH==0 && taches_clotures">
                             </el-time-picker>    

                             <span style="margin-left:10px" v-if="insertH==0 && taches_clotures">/</span>
                             
                             <el-time-picker size='mini' v-model="dte_realD" style="width:100px"
                                class="selectColDroite" type="datetime" placeholder="Date"
                                value-format="dd-MM-yyyy HH:mm" format="HH:mm" @change='handleDtePrev' :disabled="insertH==1 || etat=='Cloturé'"
                                v-if="insertH==0 && taches_clotures">
                             </el-time-picker> 
                        </el-col>
                        
                    </el-row>

                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche">

                             <span style="margin-left:20px" v-if="insertH==0 && taches_clotures">
                            Clôturé(e) le :  
                            </span>
                            <el-date-picker size='mini' v-model="dte_clot" id='detail_dte_clot' style="margin-left:3px;width:130px"
                                    class="selectColDroite" type="datetime" placeholder="Date"
                                    value-format="dd-MM-yyyy" format="dd-MM-yyyy" @change='handleDteReal' v-if="insertH==0 && taches_clotures" :disabled="insertH==1 || etat=='Cloturé'"
                                    :picker-options="datePickerOptions">
                            </el-date-picker>                          
                          
                        </el-col>
                        
                    </el-row>

                    
                    <!-- projet 
                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:10px">
                                Projet(s)
                            </span>
                        </el-col> 
                    </el-row>-->
                    

<!--
                     <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
                             <span style="margin-left:55px">
                            Transmis le : 
                            </span>
                            <el-date-picker size='mini' class="selectColDroite" v-model="dte_conf" 
                                            type="date" style="margin-left:13px;width:220px;"
                                            placeholder="Date" value-format="yyyy-MM-dd" format="dd-MM-yyyy"
                                            disabled>
                                </el-date-picker>

                            
                             <span style="margin-left:65px">
                            Accord estimé  : 
                            </span>  
                            <el-date-picker size='mini' class="selectColDroite" v-model="echeance" type="date" style="margin-left:23px;width:210px;"
                                    placeholder="Date" value-format="dd-MM-yyyy" format="dd-MM-yyyy"
                                    @change='handleEstime' :disabled="insertH==1 || etat=='Cloturé'">
                                </el-date-picker>   
                        </el-col>         
                    </el-row>

                <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >
                             <span style="margin-left:55px">
                            CA estimé  : 
                            </span>
                        &nbsp;&nbsp;&nbsp; &nbsp;
                        <el-input size='mini'  class="selectColDroite2" v-model="montant" type="text" style="margin-left:22px;width:220px;"
                                    @blur="handleMontant" :disabled="insertH==1 || etat=='Cloturé'">
                                </el-input>
                      
                            <span style="margin-left:65px">
                            Quantité estimée : 
                            </span>  
                            <el-input size='mini'  class="selectColDroite2" v-model="quantite" type="text" style="margin-left:5px;width:208px"
                                    @blur="handleQuantite" :disabled="insertH==1 || etat=='Cloturé'">
                                </el-input>    
                        </el-col>
                    </el-row>
                -->
             <br>


<!-- 
<fieldset v-if="insertH==0">
                    <legend>Les taches</legend>
                    
                 
<br>

<div class="fab-container">
                    
                </div>
                
                    
                    <el-table class="" style="height:40vh;"
                        :data="listeTaches"
                        :default-sort = "{prop: 'date', order: 'descending'}"
                        max-height="250" 
                         @row-click='rowClikedListeTache'
                      >
                        <el-table-column
                            prop="RANG"
                            label="Numéro"
                            width="70">
                        </el-table-column>
                        <el-table-column
                            prop="RESSOURCE"
                            label="Intervenant"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="TACHE2"
                            label="Tâche(s)"
                            width="350">
                        </el-table-column>
                        <el-table-column
                            prop="DTE_PREV2"
                            label="Prévu(e) le"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="DTE_REAL2"
                            label="Realisé(e) le"
                            width="90">
                        </el-table-column>
                        <el-table-column
                           
                            label="Opérations"
                            width="87">
                            <template slot-scope="scope">
                                
                                <el-button
                                slot="reference"
                                size="mini "
                                circle
                                    @click.native.prevent="handleSupprimerTache(scope.row.RANG)"
                                    class="circleButtons"
                                    icon="el-icon-delete">
                                   
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br>
                    
                    <el-row style="margin-top:15px">

                        
                        <el-col class="ColonneGauche" :span="17"  >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span style="font-size:14px">Realisé(e) le  :</span>
                            <el-date-picker size='mini' class="dateAction selectColDroite" type="date"
                                id='dialogDate_real' v-model='dialogTache.date_real'
                                placeholder="Date et heure" name='date_real' value-format="yyyy-dd-MM"
                                format="yyyy-dd-MM" >
                            </el-date-picker>
                            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                            <el-button style="margin-left: 10px;"
                            @click="newDateRealiz()"   size="mini" v-if="etat=='En cours'"
                            round>
                            Clôturer
                        </el-button>
                        <el-button   size="mini" style="margin-left: 10px;"
                            v-if="etat=='En cours'"
                            round @click="dialogFormTacheVisible = true" > Ajouter</el-button>
                        </el-col>
                    </el-row>
                    <div>
                        <el-row style="margin-top:5px;">
                            <el-col  style=" margin-bottom:10px;font-weight:bold ;font-size:16px;text-align: left;margin-left: 10px;" >
                                Observations :
                            </el-col>
                            <el-col :span="24" class="ColDroiteInterlocuteur">
                                <el-input style= "max-height: 100px; " type="textarea" placeholder="Veuillez saisir"
                                    v-model="texteObs" rows=14  
                                    class="TextareaFont" @blur='handleTextareaTache(1,1)'>
                                </el-input>
                            </el-col>
                        </el-row>
                    </div>                 
                        <el-dialog title="Ajout d'une tâche" :visible.sync="dialogFormTacheVisible" style="width:90%;margin-left:150px;margin-top:50px;"
                            @close='handleClose' class="dialogAjout">
                            <form class=""  method="post" id='formAjoutTache'>
                                <el-row>
                                    <el-col :span="4" class="ColonneGauche">
                                        Intervenant :
                                    </el-col>
                                    <el-col :span="9" class="ColDroiteDialogTache ">
                                        <el-select placeholder="Veuillez saisir" v-model='dialogTache.intervenant'
                                            id='dialogIntervenant' size='mini' name='intervenant'>
                                            <el-option  :label='null' :value='null'></el-option>
                                            <el-option v-for="item in listeIntervenants" :key="item.USER_NAME"
                                                :label="item.USER_NAME" :value="item.USER_NAME">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px;">
                                    <el-col class="ColonneGauche" :span="4">
                                        Tâche :
                                    </el-col>
                                <el-col :span="9" class="ColDroiteDialogTache ">
                                    <el-input
                                        v-model="select"
                                        id="dialogTache"
                                        :items= "afficheTache()"
                                        :value="afficheTache()"
                                        ref="dialogTache"
                                        outlined
                                        dense
                                        ></el-input>
                               </el-col>

                                </el-row>
                                <el-row style="margin-top:15px">
                                    <el-col class="ColonneGauche" :span="4">
                                        <span>
                                        Prévue le :
                                        </span>
                                    </el-col>
                                    <el-col :span="17" style="text-align:left">
                                        <el-date-picker size='mini' class="dateAction selectColDroite" type="datetime"
                                            id='dialogDate_prev' v-model='dialogTache.date_prev'
                                            placeholder="Date et heure" name='date_prev' value-format="yyyy-MM-dd HH:mm"
                                            format="dd-MM-yyyy HH:mm">
                                        </el-date-picker>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px">
                                    <el-col class="ColonneGauche" :span="4">
                                        <span>
                                        Réalisée le :
                                        </span>
                                    </el-col>
                                    <el-col :span="17" style="text-align:left">
                                        <el-date-picker size='mini' class="dateAction selectColDroite" type="date"
                                            id='dialogDate_real' v-model='dialogTache.date_real'
                                            placeholder="Date et heure" name='date_real' value-format="yyyy-MM-dd"
                                            format="dd-MM-yyyy">
                                        </el-date-picker>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px;">
                                    <el-col :span="4" class="ColonneGauche">
                                        Observations :
                                    </el-col>
                                    <el-col :span="17" class="ColDroiteDialogTache">
                                        <el-input type="textarea" placeholder="Veuillez saisir" rows=4
                                            v-model='dialogTache.observation' id='dialogObservation'
                                            class="TextareaFont" name='observation' resize='none'>
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <div class="dialog-footer">
                                    <el-button @click="dialogFormTacheVisible = false" size='mini'>Retour</el-button>
                                    <el-button type="primary" @click="handleEnregistrementTache" size='mini'>Enregistrer
                                    </el-button>
                                </div>
                            </form>
                        </el-dialog>

 </fieldset> -->
                </el-row>
                

                <el-row id='second-row' v-if=is_projet_client>

                    <el-row class="ligneAct">
                        
                        <el-col class="ColonneGauche" >

                            <span style="margin-left:20px;">
                            Action : 
                            </span>
                            
                            <el-input style="margin-left:42px;width:128px"
                              size='mini'
                              v-model="numAct"
                              :disabled="true"
                              >
                            </el-input>   


                            
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">
                        <el-col class="ColonneGauche">

                            <span style="margin-left:20px">
                            Nature : 
                            </span>

                            <el-select v-model="nature" size='mini' placeholder="" class="selectColDroite2"
                             filterable :filter-method="naturefilterHandler"
                                  @change="handleSelectChange('NATURE')" style="margin-left:38px;width:355px;" :disabled="etat=='Cloturé'"
                                    >
                                    <el-option :key='null' :label='null' :value='null'></el-option>
                                    <el-option v-for="item in optionsNature" 
                                        style="text-align:left"
                                        :key="item.LIB_50" 
                                        :label="item.LIB_50"
                                        :value="item.CDE_TABLE">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:20px">
                            Statut : 
                            </span>
                            &nbsp;&nbsp;&nbsp;
                            <el-select v-model="statut" size='mini' placeholder="" class="selectColDroite2" style="margin-left:43px;width:355px;"
                                    @change="handleSelectChange('STATUT')" :disabled="etat=='Cloturé'">
                                    <el-option :key='null' :label='null' :value='null'></el-option>
                                    <el-option v-for="item in optionsStatut"
                                        style="text-align:left" 
                                            :key="item.LIB_50" 
                                            :label="item.LIB_50"
                                            :value="item.CDE_TABLE">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:20px">
                            Intérêt : 
                            </span>
                        
                            <el-select v-model="interet" size='mini' placeholder="" class="selectColDroite2" style="margin-left:38px;width:355px;"
                             filterable :filter-method="interetfilterHandler" 
                                    @change="handleSelectChange('INTERET')" :disabled="etat=='Cloturé'">
                                    <el-option :key='null' :label='null' :value='null'></el-option>
                                    <el-option v-for="item in optionsInteret"
                                    style="text-align:left" 
                                        :key="item.LIB_50" 
                                        :label="item.LIB_50"
                                        :value="item.CDE_TABLE">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>


                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:22px">
                            Origine : 
                            </span>
                            &nbsp;&nbsp;&nbsp;
                            <el-select v-model="origine" size='mini' placeholder="" class="selectColDroite2" style="margin-left:35px;width:355px;" 
                             filterable :filter-method="originefilterHandler" 
                                    @change="handleSelectChange('ORIGINE')" :disabled="etat=='Cloturé'">
                                    <el-option :key='null' :label='null' :value='null'></el-option>
                                    <el-option v-for="item in optionsOrigine" align='left'
                                            :key="item.LIB_50" 
                                            :label="item.LIB_50"
                                            :value="item.CDE_TABLE">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:23px">
                            Activité : 
                            </span>

                            <el-select v-model="activite" size='mini' placeholder="" class="selectColDroite2"
                             filterable :filter-method="activitefilterHandler" 
                                  @change="handleSelectChangeTache('activite')" style="margin-left:34px;width:355px;" :disabled="etat=='Cloturé'">
                                    <el-option :key='null' :label='null' :value='null'></el-option>
                                    <el-option v-for="item in activites" align='left'
                                        :key="item.LIB_50" 
                                        :label="item.LIB_50"
                                        :value="item.CDE_TABLE">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:24px">
                            Devis : 
                            </span>

                            <el-select v-model="devis" size='mini' placeholder="" class="selectColGauche" style="margin-left:45px;width:128px;"
                                    @change="handleSelectChange('DEVIS')" :disabled="insertH==1 || etat=='Cloturé'">
                                    <el-option v-for="item in optionsDevis" 
                                        :key="item.NUM_DEV" 
                                        :label="item.NUM_DEV"
                                        :value="item.NUM_DEV">
                                    </el-option>
                            </el-select>

                            <span style="margin-left:15px">
                            Remis le :
                            </span>
                            <el-date-picker size='mini' class="selectColDroite" v-model="dte_conf" 
                                            type="date" style="margin-left:5px;width:140px;"
                                            placeholder="Date" value-format="yyyy-MM-dd" format="dd-MM-yyyy"
                                            disabled>
                            </el-date-picker>
                        </el-col>
                    </el-row>
                    <el-row class="ligneAct">
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:24px">
                            CA estimé  : 
                            </span>
                        
                            <el-input size='mini' class="selectColDroite2" v-model="montant" type="text" style="margin-left:17px;width:128px;"
                                    @blur="handleMontant" :disabled="insertH==1 || etat=='Cloturé'">
                            </el-input>
                      
                            <span style="margin-left:15px">
                            Quantité : 
                            </span>  
                            <el-input size='mini' class="selectColDroite2" v-model="quantite" type="text" style="margin-left:5px;width:140px"
                                    @blur="handleQuantite" :disabled="insertH==1 || etat=='Cloturé'">
                                </el-input>    
                        </el-col>
                    </el-row>
                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:24px">
                            N° Affaire : 
                            </span>

                            <el-select v-model="affaire" size='mini' placeholder="" class="selectColGauche" style="margin-left:18px;width:128px;"
                                    @change="handleSelectChange('AFFAIRE')" :disabled="insertH==1 || etat=='Cloturé'">
                                    <el-option v-for="item in optionsAffaire" 
                                        :key="item.NUM_AFFAIRE" 
                                        :label="item.NUM_AFFAIRE"
                                        :value="item.NUM_AFFAIRE">
                                    </el-option>
                            </el-select>

                            <span style="margin-left:14px">
                            Conducteur
                            </span>
                            <el-input style="margin-left:-3px;width:140px"
                              size='mini'
                              v-model="conducteur"
                              :disabled="true"
                             >
                            </el-input> 
                        </el-col>
                    </el-row>   
                    <el-row class="ligneAct">  
                        <el-col class="ColonneGauche" >
                            <span style="margin-left:24px">
                            Site : 
                            </span>
                            <el-input style="margin-left:54px;width:128px"
                              size='mini'
                              v-model="siteAff"
                              :disabled="true"
                             >
                            </el-input> 
                        </el-col>
                    </el-row>  
                </el-row>      

             <el-row>
                <el-row>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 30px;background-color: #6c757d;color:white;" @click="projet_client()" class="btn-projet"> 
                    <span class="hintProjet">Projets </span>
                </el-button>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;" @click="Enregistrer_action()" :disabled="etat=='Cloturé'" class="btn-enregistrer">
                    <span class="hintEnregistrer">Enregistrer </span>
                </el-button>    
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;" @click="handleUpdateEtat"  v-if="etat!='Cloturé' " :disabled="insertH!=0 || !taches_clotures || etat!='En cours'" class="btn-cloturer">
                    <span class="hintCloture">Clôturer</span>
                </el-button>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;" @click="handleUpdateEtat" v-if="etat=='Cloturé' " class="btn-decloturer">
                    <span class="hintDecloture">Déclôturer</span>
                </el-button>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;"  @click="dialogCompteRendu =true"  :disabled="insertH!=0 || etat=='Cloturé'" class="btn-compte">
                    <span class="hintCompte">Compte rendu</span>
                </el-button> 
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;"  @click="dialogTabledocuments = true" :disabled="insertH!=0 || etat=='Cloturé'" class="btn-document">
                    <span class="hintDocument">Documents</span>
                </el-button>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;"  @click="handleRapport" :disabled="insertH!=0 ||etat=='Cloturé'" class="btn-edition">
                    <span class="hintEdition">Rapport</span>
                </el-button>
                <el-button size="mini" style="border-radius: 5px;float: left;margin-left: 20px;background-color: #6c757d;color:white;" @click="nouveau()" :disabled="etat=='Cloturé'" class="btn-nouveau">
                    <span class="hintNouveau">Nouveau</span>
                </el-button> 
                </el-row>
            <br><br><br>
<fieldset v-if="insertH==0">
                    <legend>Contacts</legend>
                    
<br>
                            <el-dialog title="Ajout d'interlocuteurs" :visible.sync="dialogFormInterlocuteurVisible"
                                style="width:90%;height:100%; margin-left:150px;" @close='handleClose' class="dialogAjout">
                                <el-table ref='tableInterlocuteur' :data=listeInterlocteursPotentiels height=400
                                    stripe @selection-change="handleSelectionChange" class="tableCenter"
                                    empty-text="Aucun résultat !">
                                    <el-table-column type="selection" header-align='center' align='right'
                                        width="45">
                                    </el-table-column>
                                    <el-table-column prop="INTERLOCUTEUR" label="Interlocuteur"
                                        class-name='colDialogInterlocuteur' align='left' width="200">
                                    </el-table-column>
                                    <el-table-column prop="FONCTION" label="Fonction" width="500">
                                    </el-table-column>
                                </el-table>
                                <form class=""  method="post" id='formAjoutTache'>
                                    <div class="dialog-footer" >
                                        <el-button type="primary" @click="handleEnregistrementInterlocuteurs"
                                            size='mini'>Ajouter à l'action</el-button>
                                        <el-button @click="dialogFormInterlocuteurVisible = false" size='mini'>
                                            Retour
                                        </el-button>
                                        <el-button style="background-color: #32CD32; color: white"
                                            @click="handleAjouterInterlocuteurCollapse" size='mini'>
                                            Ajouter à la liste
                                        </el-button>
                                        <!--<el-button type="danger" @click="SuppressionInterlocuteurs" size='mini'>Supprimer de la liste</el-button>-->
                                    </div>
                                </form>
                            </el-dialog>
                            
                            <el-dialog title="Ajout d'un interlocuteur"
                                :visible.sync="handleAjouterInterlocuteurVisible" style="width:500px; margin-left: 30%;"
                                @close='handleClose1' class="dialogAjout">
                                <form class=""  method="post" id='formAjoutTache'>
                                    <br />
                                    <el-row>
                                        <el-col  class="ColonneGauche">
                                            Civilité* :
                                        
                                            <el-radio-group name='civilite' id='dialogCivilite' style="margin-left: 35px;"
                                                v-model='dialogInterlocuteur.civilite' size="small">
                                                <el-radio label="1" border>Madame</el-radio>
                                                <el-radio label="2" border>Monsieur</el-radio>
                                            </el-radio-group>
                                        </el-col>
                                    </el-row>
                                  
                                    <el-row style="margin-top:15px;">
                                        <el-col class="ColonneGauche">
                                            Prénom* :
                                        
                                            <el-input type="text" name='prenom' id='dialogPrenom' style="margin-left: 22px; width:250px"
                                                placeholder="Veuillez saisir" rows=4
                                                v-model='dialogInterlocuteur.prenom' class="TextareaFont"
                                                resize='none' size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                   
                                    <el-row style="margin-top:15px;">
                                        <el-col class="ColonneGauche">
                                            Nom* :
                                        
                                            <el-input type="text" name='nom' id='dialogNom' style="margin-left: 43px; width:250px"
                                                placeholder="Veuillez saisir" rows=4
                                                v-model='dialogInterlocuteur.nom' class="TextareaFont" resize='none'
                                                size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    
                                    <el-row style="margin-top:15px;">
                                        <el-col  class="ColonneGauche">
                                            Fonction* :
                                        
                                            <el-select placeholder="Veuillez choisir" style="margin-left: 18px; width:250px"
                                                v-model='dialogInterlocuteur.fonction' id='dialogFonction'
                                                size='mini' name='fonction'>
                                                <el-option :key='null' :label='null' :value='null'></el-option>
                                                <el-option v-for="item in optionsFonction" :key="item.FONCTION"
                                                    :label="item.FONCTION" :value="item.FONCTION">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                    
                                    <el-row style="margin-top:15px;">
                                        <el-col class="ColonneGauche">
                                            Téléphone:
                                        
                                            <el-input type="text" name='telPortable' id='dialogTelPortable' style="margin-left: 18px; width:250px"
                                                placeholder="Option de saisie" rows=4
                                                v-model='dialogInterlocuteur.telPortable' class="TextareaFont"
                                                resize='none' size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    <br />
                                    <el-row style="margin-top:15px;">
                                        <el-col  class="ColonneGauche">
                                            Email :
                                        
                                            <el-input type="email" name='email' id='dialogEmail' style="margin-left: 48px; width:250px"
                                                placeholder="Option de saisie" rows=4
                                                v-model='dialogInterlocuteur.email' class="TextareaFont"
                                                resize='none' size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    
                                    <el-row style="margin-top:15px" hidden>
                                        <el-col :span="4" class="ColonneGauche">
                                            <span>
                                            Créée le :
                                            </span>
                                        </el-col>
                                        <el-col :span="17" style="text-align:left">
                                            <el-date-picker type="date" name="date_creat" id='dialogDate_creat'
                                                placeholder="Date" rows=4 v-model='dialogInterlocuteur.date_creat'
                                                class="TextareaFont" format="yyyy-MM-dd" size='mini'>
                                            </el-date-picker>
                                        </el-col>
                                    </el-row>
                                    <el-row style="margin-top:15px" hidden>
                                        <el-col :span="4" class="ColonneGauche">
                                            <span>
                                            MAJ le :
                                            </span>
                                        </el-col>
                                        <el-col :span="17" style="text-align:left">
                                            <el-date-picker type="date" name="date_MAJ" id='dialogDate_MAJ'
                                                placeholder="Date" rows=4 v-model='dialogInterlocuteur.date_MAJ'
                                                class="TextareaFont" format="yyyy-MM-dd" size='mini'>
                                            </el-date-picker>
                                        </el-col>
                                    </el-row>
                                    <el-row style="margin-top:15px;" hidden>
                                        <el-col :span="4" class="ColonneGauche">
                                            Inactif :
                                        </el-col>
                                        <el-col :span="6" class="ColDroiteDialogTache ">
                                            <el-input type="text" name='inactif' id='dialogInactif'
                                                placeholder="Option de saisie" rows=4
                                                v-model='dialogInterlocuteur.inactif' class="TextareaFont"
                                                resize='none' size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    <el-row style="margin-top:15px;" hidden>
                                        <el-col :span="4" class="ColonneGauche">
                                            Fax :
                                        </el-col>
                                        <el-col :span="6" class="ColDroiteDialogTache ">
                                            <el-input type="text" name='fax' id='dialogFax'
                                                placeholder="Option de saisie" rows=4
                                                v-model='dialogInterlocuteur.fax' class="TextareaFont" resize='none'
                                                size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    <el-row style="margin-top:15px;" hidden>
                                        <el-col :span="4" class="ColonneGauche">
                                            Type :
                                        </el-col>
                                        <el-col :span="6" class="ColDroiteDialogTache ">
                                            <el-input type="text" name='type' id='dialogType'
                                                placeholder="Option de saisie" rows=4
                                                v-model='dialogInterlocuteur.type' class="TextareaFont"
                                                resize='none' size='mini' show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                    <div class="dialog-footer">
                                        <el-button @click="handleAjouterInterlocuteurVisible = false" size='mini'>
                                            Retour
                                        </el-button>
                                        <el-button type="primary" @click="handleAjouterInterlocuteur" size='mini'>
                                            Enregistrer
                                        </el-button>
                                    </div>
                                </form>
                            </el-dialog>
                            <el-collapse>
                                
                                    <div v-for='(interlocuteur,index) in listeInterlocteurs' :key="interlocuteur.index">
                                        <el-collapse-item style="display:inline;font-size:11px">
                                            <el-divider class="dividerInterlocuteur"><i
                                                class="el-icon-document"></i></el-divider>
                                            <template slot="title" style="display:inline-block">
                                                <el-col :span="15"
                                                    class="ColGaucheInterlocuteur"
                                                    v-if="((interlocuteur.PRENOM_CONTAC.length)+(interlocuteur.NOM_CONTAC.length))<30" >
                                                    <i class="header-icon el-icon-user"></i>
                                                    <span class="infoInterlocuteur">{{interlocuteur.CIVIL}} {{interlocuteur.PRENOM_CONTAC}} {{interlocuteur.NOM_CONTAC}}{{interlocuteur.FONCTION}}</span>
                                                </el-col>
                                                <el-col :span="15" v-else class="ColGaucheInterlocuteur"><i
                                                    class="header-icon el-icon-user"></i>
                                                    <span class="infoInterlocuteurSmall">{{interlocuteur.CIVIL}} {{interlocuteur.PRENOM_CONTAC}} {{interlocuteur.NOM_CONTAC}}</span> <span
                                                        class="fonctionInterlocuteurSmall">{{interlocuteur.FONCTION}}</span>
                                                </el-col>
                                                <div class="colDroiteRencontre">
                                                    Vu :
                                                    <el-checkbox class="rencontre"
                                                        v-model="listeInterlocteurs[index].VU"
                                                        true-label=1 :false-label=0
                                                        @change='handleRencontre(index,interlocuteur.NUM_CONTAC,interlocuteur.TYPE_CONTAC,interlocuteur.TIERS,numAct)'>
                                                    </el-checkbox>
                                                </div>
                                            </template>
                                            <div>
                                                <el-row>
                                                    <el-col :span="7" class="ColGaucheInterlocuteur"> <i
                                                        class="header-icon el-icon-location"></i> Adresse :
                                                         {{interlocuteur.ADR_0}} {{interlocuteur.ADR_1}} {{interlocuteur.ADR_2}} {{interlocuteur.ADR_3}} {{interlocuteur.CODE_POSTAL}} {{interlocuteur.PAYS}}
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="7" class="ColGaucheInterlocuteur"> <i
                                                        class="header-icon el-icon-phone"></i> Téléphone fixe :
                                                        {{interlocuteur.TELEPHONE}} 
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="7" class="ColGaucheInterlocuteur"> <i
                                                        class="header-icon el-icon-mobile"></i> Téléphone mobile
                                                        : {{interlocuteur.MOBILE}} 
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="7" class="ColGaucheInterlocuteur"> <i
                                                        class="header-icon el-icon-message"></i> Mail : {{interlocuteur.E_MAIL}} 
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-button type="danger"
                                                        @click="handleRetirerInterlocuteur(interlocuteur.NUM_CONTAC)"
                                                        size='mini' style="margin-top:10px">Supprimer</el-button>
                                                </el-row>
                                            </div>
                                        </el-collapse-item>
                                    </div>
                            </el-collapse>
                            <el-row>
                                <el-button  @click="recupInterlocuteursPotentiels" size='mini'
                                    style="border-radius: 5px;margin-top:20px;margin-bottom: 10px;" :disabled="etat=='Cloturé'">Ajouter interlocuteur</el-button>
                            </el-row>
                                           
                </fieldset>

                <br><br><br><br>
            </el-row>

    </div>
</template>
<script>


import $ from 'jquery'
import axios from 'axios';
import {BACKEND_URL} from './GLOBALS'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Vue from 'vue'
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 
    export default {
      data() {
        return {
            activites:[],
            activitesInit:[],
            activite:'',
            taches_clotures:true,
            listeCommercial:[],
            insertH:0,
            dialogCompteRendu:false,
            dialogTabletaches:false,
            dialogTabledocuments:false,
            auteur:'',
            superviseur:'',
            files: [],
            publicPath: process.env.BASE_URL,
            optionFrequence:['Mois','Trimestre','Semestre'],
            editor: ClassicEditor,      
            editorConfig: {
            },
            activeName:'detail',
            windowData:window,
            numAct:'AC2015',
            action:{},
            tabPosition: 'top',
            interlocuteurs: [],
            nom_cli:'',
            cde_cli:'',
            nom_com:'',
            objet:'',
            frequence:'',
            etat:'',
            priorite:'',
            dte_creat:moment(new Date(), "DD-MM-yyyy").format("DD-MM-yyyy"),
            dte_prev:'',
            dte_real:'',
            dte_clot:'',
            dte_reall:'',
            dte_prevD:'',
            dte_prevF:'',
            dte_realD:'',
            dte_realF:'',
            commentCompteRend:'',
            commentPrep:'',
            nature:'',
            origine:'',
            interet:'',
            statut:'',
            devis:'',
            affaire: '',
            conducteur: '',
            siteAff: '',
            echeance:'',
            dte_conf:'',
            num_dev: '',
            montant: '',
            quantite:'',
            NUM_AFFAIRE:'',
            reactiviteDetail:'',
            rencontre:'',
            optionsNom_Cli: [{
                value: 'nom_cli',
                label: ''
            }],
            optionsPriorite:'',
            optionsObjet:'',
            optionsObjetInit:'',
            optionsNature:'',
            optionsNatureInit:'',
            optionsOrigine:'',
            optionsOrigineInit:'',
            optionsInteret:'',
            optionsInteretInit:'',
            optionsStatut: '',
            optionsDevis: '',
            optionsAffaire: '',
            listeTechniciens: [],
            listePrestataires: [],
            listePrestatairesInit: [],
            technicien: '',
            prestataire: '',
            nom: '',
            listeIntervenants:[],
            listeInterlocteurs: [],
            dialogFormInterlocuteurVisible: false,
            handleAjouterInterlocuteurVisible: false,
            listeInterlocteursPotentiels: [],
            multipleSelection: [],
            optionsFonction: '',
            dialogInterlocuteur: {
                civilite: '1',
                prenom: '',
                nom: '',
                fonction: '',
                telFixe: '',
                telPortable: '',
                email: '',
                adr0: '',
                adr1: '',
                adr2: '',
                adr3: '',
                cp: '',
                pays: '',
                internet: '',
                fax: '',
                type: '1',
                inactif: '0',
                date_creat: '',
                date_MAJ: ''
            },
            // ------------------------ Onglet 3 -----------------------------
            listeTaches: [],

            taches_LIB: {
                taches_LIB_ID: []
            },
            taches_OBS: {
                taches_OBS_ID: []
            },
            taches_INT: {
                taches_INT_ID: []
            },
            taches_PRE: {
                taches_PRE_ID: []
            },
            taches_REA: {
                taches_REA_ID: []
            },
            optionsRessource:'',
            dialogFormTacheVisible: false,
            formTache: {
                Intervenant: '',
                tache: '',
                date_prev: '',
                date_real: '',
                observation: ''
            },
            dialogTache: {
                intervenant: '',
                tache: '',
                date_prev: new Date(),
                date_real: '',
                observation: '',
            },
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,

            // ajout de documents
            fileList: [],
            theBlob: '',
            slectTacheCreate:'',
            index:-1,
            texteObs:'',
            RANGCourant:-1,
            select:'',
            listeTacheComplete:[],
            newDTE_REAL2:'',
            dteProch:'',
            detail_freq:'',
            is_projet_client:false,
            datePickerOptions: {
                disabledDate: this.disabledDueDate
            }

        }
      },
      watch: { $route(to, from) {  //console.log('test')
        if(to === from){ location.reload(); } } },
        components: {
        },
      created() {
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
      var self= this
      this.numAct = this.$route.query.num_act
      if (typeof this.$route.query.num_act == 'undefined') {this.insertH=1};
      if (typeof this.$route.query.new != 'undefined') {document.location.href="/#/admin/action";};
      if(!this.insertH){
        var request = $.ajax({
            url: BACKEND_URL+"controller/action.php",
            async: false,
            type: "POST",
            data: {
                num_act_vue:this.$route.query.num_act
            },
            dataType: "html",
            success: function(data) {
                var dataParsed = JSON.parse(data)

                self.devis=dataParsed.action.NUM_DEV
                self.affaire=dataParsed.action.NUM_AFFAIR
                self.technicien=dataParsed.action.RESSOURCE
                self.prestataire=dataParsed.action.PRESTATAIRE
                self.conducteur=dataParsed.action.TECHNICO
                self.siteAff=dataParsed.action.SITE
                self.activites=dataParsed.activites
                self.activitesInit=dataParsed.activites
                self.activite=dataParsed.action.ACT
                self.action=dataParsed.action
                self.optionsPriorite=dataParsed.listeSelectPriorite
                self.optionsObjet=dataParsed.listeSelectObjet
                self.optionsObjetInit=dataParsed.listeSelectObjet
                self.listeProfil=dataParsed.listeSelectProfil
                self.optionsNature=dataParsed.listeSelectNature
                self.optionsNatureInit=dataParsed.listeSelectNature
                self.optionsOrigine=dataParsed.listeSelectOrigine
                self.optionsOrigineInit=dataParsed.listeSelectOrigine
                self.optionsInteret=dataParsed.listeSelectInteret
                self.optionsInteretInit=dataParsed.listeSelectInteret
                self.optionsStatut=dataParsed.listeSelectStatut
                self.optionsDevis=dataParsed.listeSelectDevis
                self.optionsAffaire=dataParsed.listeSelectAffaire
                self.listeInterlocteurs=dataParsed.listeInterlocuteurs
                self.listeTaches=dataParsed.listeTaches
                self.listeTechniciens=dataParsed.listeTechniciens
                self.listePrestataires=dataParsed.listePrestataires
                self.listePrestatairesInit=dataParsed.listePrestataires
                     
                self.listeIntervenants=dataParsed.listeIntervenants
                self.optionsFonction=dataParsed.listeFonctions
                self.listeTacheComplete=dataParsed.listeTacheComplete
                self.cde_cli=dataParsed.action.CDE_CLI
                self.auteur=dataParsed.action.AUTEUR
                
                self.superviseur=dataParsed.action.SUPERVISEUR
                self.nom_cli=dataParsed.action.NOM_CLI
                self.nom_com=dataParsed.action.VENDEUR
                self.objet=dataParsed.action.OBJET
                self.etat= dataParsed.action.ETAT
                self.priorite=dataParsed.action.PRI
                self.quantite=dataParsed.action.QUANTITE
                self.montant=dataParsed.action.MONTANT


                self.dte_creat=dataParsed.action.DTE_CREAT
                self.dte_prev=dataParsed.action.DTE_PREV
                self.dte_prevD=dataParsed.action.HRE_DEB_PREV
                self.dte_prevF=dataParsed.action.HRE_FIN_PREV

            
                self.dte_real=dataParsed.action.DTE_REAL
                self.dte_clot=dataParsed.action.DTE_CLOT
                self.dte_realD=dataParsed.action.DTE_REAL
                self.dte_realF=dataParsed.action.DTE_REALF
                self.der_visit=dataParsed.action.DER_VISIT
                self.dte_visite=dataParsed.action.DTE_VISITE
                self.commentCompteRend=dataParsed.action.COMPTE_RENDU
                self.commentPrep=dataParsed.action.PREPARATION
                self.nature=self.getCDE_TABLEFromLIB(self.optionsNature, dataParsed.action.NATURE)
                self.origine=dataParsed.action.ORG
                self.interet=dataParsed.action.IT
                self.statut=dataParsed.action.STA
                
                self.echeance=dataParsed.action.DTE_SIGN
                self.dte_conf=dataParsed.getdte_conf
                self.NUM_AFFAIRE=dataParsed.action.NUM_AFFAIR
                self.nom=dataParsed.action.NOM
                self.detail_freq=dataParsed.action.FREQUENCE
                if(dataParsed.action.DEVIS!=null && dataParsed.action.DEVIS.length>0)
                self.num_dev=dataParsed.action.DEVIS[0].NUM_DEV
                if(dataParsed.action.DEVIS ==null)
                    self.devis = (self.optionsDevis[self.optionsDevis.length - 1]).NUM_DEV
                if(dataParsed.action.NUM_AFFAIR ==null && self.optionsAffaire.length > 0) {
                    self.affaire = (self.optionsAffaire[self.optionsAffaire.length - 1]).NUM_AFFAIRE
                    self.conducteur= (self.optionsAffaire[self.optionsAffaire.length - 1]).COND_TRAV
                    self.siteAff= (self.optionsAffaire[self.optionsAffaire.length - 1]).SITE_EXECUTION
                }
            }
        })
        for (var i=0;i<this.listeTaches.length;i++){
            /*var d=this.listeTaches[i].DTE_REAL2;
            var dd=d.split('/')[0]
            var mm=d.split('/')[1]
            var yyyy=d.split('/')[3]
            var datee= new Date(yyyy,mm,dd);*/
            if (this.listeTaches[i].DTE_REAL2==null)  this.taches_clotures=false;
            
       
        }
        
        var vm = this;
        var request = $.ajax({
            url: BACKEND_URL+"controller/action.php",
            async: true,
            type: "POST",
            data: {
                'ongletBase': 1,
                'action': this.numAct
            },
            dataType: "json",
            success: function(data) {
                console.log(data)
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        var img = data[i]['data'].split(',');
                        var contentType = img[0];
                        var file_name = img[1];
                        const byteCharacters = atob(img[2]);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: contentType
                        });
                        var objectURL = URL.createObjectURL(blob);

                        vm.fileList.push({
                            'name': file_name,
                            'url': objectURL,
                            'image_id':data[i]['image_id']
                        })
                    }
                }
            }
        });

        }
        else{
            var self=this
            self.numAct='';
           
            $.ajax({
            url: BACKEND_URL+"controller/action.php",
            async: true,
            type: "POST",
            data: {
                'zebimiao': 1,
            },
            dataType: "json",
            success: function(data) {
                self.optionsPriorite=data.listeSelectPriorite
                self.optionsObjet=data.listeSelectObjet
                self.optionsObjetInit=data.listeSelectObjet
                self.optionsNature=data.listeSelectNature
                self.optionsNatureInit=data.listeSelectNature
                self.optionsInteret=data.listeSelectInteret
                self.optionsInteretInit=data.listeSelectInteret
                self.optionsStatut=data.listeSelectStatut
                self.optionsOrigine=data.listeSelectOrigine
                self.optionsOrigineInit=data.listeSelectOrigine
                self.optionsDevis=data.listeSelectDevis
                self.optionsAffaire=data.listeSelectAffaire
                self.listeTechniciens=data.listeTechniciens
                self.listePrestataires=data.listePrestataires
                self.listePrestatairesInit=data.listePrestataires
                self.superviseur=data.superviseur
                self.nom_cli=data.nom_cli
                self.nom_com=self.$store.getters.vendeur
                self.auteur=data.cde_profil
                self.montant=data.montant
                self.quantite=data.quantite
                self.echeance=data.echeance

            }
        });
            $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: true,
            type: "POST",
            data: {
            },
            dataType: "html",
            success: function(data) {
                var dataParsed = JSON.parse(data)
                self.listeCommercial=dataParsed.listeCommercial
                self.templisteCommercial=dataParsed.listeCommercial
                self.listeEtat=dataParsed.listeEtat
                self.listeSecteur=dataParsed.listeSecteur
                self.tempoptionsNom_Cli=dataParsed.optionsNom_Cli
                if(self.nom_com!=null)
                self.optionsNom_Cli = self.tempoptionsNom_Cli.filter(row => (row.vendeur != null && row.vendeur.toUpperCase().startsWith(self.nom_com.toUpperCase())) || (row.vendeur2 != null && row.vendeur2.toUpperCase().startsWith(self.nom_com.toUpperCase())) ).sort((a, b) => a.LABEL.localeCompare(b.LABEL)).slice(0, 2000)
                else
                self.optionsNom_Cli=dataParsed.optionsNom_Cli.sort((a, b) => a.LABEL.localeCompare(b.LABEL)).slice(0, 2000)//.filter(row => row.vendeur != null);//&& row.CRM != 0
                self.optionsObjet=dataParsed.optionsObjet
                self.optionsObjetInit=dataParsed.optionsObjet
                self.montant=dataParsed.montant
                self.quantite=dataParsed.quantite
                self.echeance=dataParsed.echeance
                self.auteur=dataParsed.cde_profil  
                self.optionsPriorite=dataParsed.optionsPriorite
                self.optionsNature=dataParsed.listeSelectNature
                self.optionsNatureInit=dataParsed.listeSelectNature
                self.optionsOrigine=dataParsed.listeSelectOrigine
                self.optionsOrigineInit=dataParsed.listeSelectOrigine
                self.optionsInteret=dataParsed.listeSelectInteret
                self.optionsInteretInit=dataParsed.listeSelectInteret
                self.optionsStatut=dataParsed.listeSelectStatut
                self.activites=dataParsed.listeTaches
                self.activitesInit=dataParsed.listeTaches
                self.listeTechniciens=dataParsed.listeTechniciens
                self.listePrestataires=dataParsed.listePrestataires
                self.listePrestatairesInit=dataParsed.listePrestataires
            }
        })
            
        }

      },
      watch: {
      },
      components: {
      },
      computed: {
              

          dateNext(){
                   
                var dte_real=this.dte_real;
                if (this.detail_freq=='SEMESTRE'){
                 return moment(dte_real,'DD-MM-yyyy HH:mm ').add(6, 'months').format('DD-MM-yyyy HH:mm');
                }
                 else if(this.detail_freq=='TRIMESTRE'){
                     return moment(dte_real,'DD-MM-yyyy HH:mm').add(3, 'months').format('DD-MM-yyyy HH:mm');
                } 
             
                 else if(this.detail_freq=='MOIS'){
                 return  moment(dte_real,'DD-MM-yyyy HH:mm').add(1, 'months').format('DD-MM-yyyy HH:mm');
                }

          }
      },
      methods: {

        disabledDueDate: function (date) {
            return date < new Date( moment(this.dte_creat, "DD-MM-yyyy HH:mm").subtract(18,'hour').format(
               "YYYY-MM-DD HH:mm"))
        },
        
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function (newFile, oldFile) {
          if (newFile && oldFile && !newFile.active && oldFile.active) {
            // Get response data
            console.log('response', newFile.response)
            if (newFile.xhr) {
              //  Get the response status code
              console.log('status', newFile.xhr.status)
            }
          }
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
          if (newFile && !oldFile) {
            // Filter non-image file
            if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
              return prevent()
            }
          }

          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
        },
        commercial_change(){
            var self=this
            if(self.nom_com==null) {
                self.listeCommercial = self.templisteCommercial;
                //self.optionsNom_Cli = self.tempoptionsNom_Cli;
            }
            else {
                if(self.nom_com!=null)
                self.optionsNom_Cli = self.tempoptionsNom_Cli.filter(row => (row.vendeur != null && row.vendeur.toUpperCase().startsWith(self.nom_com.toUpperCase())) || (row.vendeur2 != null && row.vendeur2.toUpperCase().startsWith(self.nom_com.toUpperCase())) ).sort((a, b) => a.LABEL.localeCompare(b.LABEL)).slice(0, 2000)
                else
                self.optionsNom_Cli=dataParsed.optionsNom_Cli.sort((a, b) => a.LABEL.localeCompare(b.LABEL)).slice(0, 2000)//.filter(row => row.vendeur != null);//&& row.CRM != 0
            }
        },
        clientfilterHandler(value) {
            var self=this
            self.optionsNom_Cli = self.tempoptionsNom_Cli.filter(row => row.LABEL != null && row.LABEL.toUpperCase().startsWith(value.toUpperCase())).sort((a, b) => a.LABEL.localeCompare(b.LABEL)).slice(0, 2000)
        },
        objetfilterHandler(value) {
            var self=this
            self.optionsObjet = self.optionsObjetInit.filter(row => row.LIB_50.toUpperCase().startsWith(value.toUpperCase()));
        },
        prestatairefilterHandler(value) {
            var self=this
            self.listePrestataires = self.listePrestatairesInit.filter(row => row.RES_LIB.toUpperCase().startsWith(value.toUpperCase()));
            self.listePrestataires = self.listePrestataires.sort((a, b) => a.LABEL.localeCompare(b.LABEL))
        },
        naturefilterHandler(value) {
            var self=this
            self.optionsNature = self.optionsNatureInit.filter(row => row.LIB_50.toUpperCase().startsWith(value.toUpperCase()));
        },
        originefilterHandler(value) {
            var self=this
            self.optionsOrigine = self.optionsOrigineInit.filter(row => row.LIB_50.toUpperCase().startsWith(value.toUpperCase()));
        },
        interetfilterHandler(value) {
            var self=this
            self.optionsInteret = self.optionsInteretInit.filter(row => row.LIB_50.toUpperCase().startsWith(value.toUpperCase()));
        },
        activitefilterHandler(value) {
            var self=this
            self.activites = self.activitesInit.filter(row => row.LIB_50.toUpperCase().startsWith(value.toUpperCase()));
        },
         client_change() {
            var self=this
            if(self.nom_cli==null) {
                self.listeCommercial = self.templisteCommercial;
                //self.optionsNom_Cli = self.tempoptionsNom_Cli;  
            }
            else {
                    /*
                 $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'get_commercial_client': 1,
                    'client':self.nom_cli,
                    
                },
                dataType: "html",
                success: function(data) {
                    self.listeCommercial=data
                    self.verifier_champs()
                    }
                });*/
                const cli = self.optionsNom_Cli.find(element => element.CDE_CLI == self.nom_cli)
                self.nom_com = cli.vendeur;
                if(cli.vendeur ==null && cli.vendeur2 != null)
                    self.nom_com = cli.vendeur2;
            }
         },
        verifier_champs(save=0){
            if(this.nom_com =="" || this.nom_cli =="" || this.priorite=="" || this.objet=="" || this.auteur=="" || typeof this.nom_cli =='undefined' || this.dte_prev ==""){
               
            } else
            {
                var self=this;
                $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'insert_into_actioncrm': 1,
                    'CDE_CLI':self.nom_cli,
                    'OBJET':self.objet,
                    'AUTEUR':self.auteur,
                    'VENDEUR':self.nom_com,
                    'PRIORITE':self.priorite,
                    'DTE_CREAT':self.dte_creat,
                    'DTE_PREV':self.dte_prev,
                    'HRE_DEB_PREV':self.dte_prevD,
                    'HRE_FIN_PREV':self.dte_prevF,
                    'RESSOURCE':self.technicien,
                    'PRESTATAIRE':self.prestataire
                    },
                    dataType: "html",
                    success: function(data) {
                        if(save) 
                            self.Update_projet(data, save)
                        else {
                            document.location.href=window.location.href +'?num_act='+data;
                            location.reload();
                        }
                    }
                });
            } 
        },
        Enregistrer_action(){
            if(this.nom_cli == null || this.nom_cli == ''){
                alert('Attention ! Champ vide') 
                document.getElementById('CbClient').focus() 
                return
            }
            if(this.nom_com == null || this.nom_com == ''){
                alert('Attention ! Champ vide') 
                document.getElementById('CbCommercial').focus() 
                return
            }    

            if(this.objet == null || this.objet == ''){
                alert('Attention ! Champ vide') 
                document.getElementById('Cbobjet').focus() 
                return
            }
            if(this.priorite == null || this.priorite == ''){
                alert('Attention ! Champ vide') 
                document.getElementById('CbPriorite').focus() 
                return
            }         
            if(this.dte_creat == null || this.dte_creat == '' ){
                alert('Attention ! Champ vide') 
                document.getElementById('date_crt').focus()
                return
            }
            if(this.dte_prev == null || this.dte_prev == '' ){
                alert('Attention ! Champ vide') 
                document.getElementById('date_pre').focus() 
                return
            }
          
                 
            if(this.numAct =="")          
                this.verifier_champs(1)
            else
                this.Update_projet(this.numAct) 
        },
        projet_client(){
            let client_span = document.getElementsByClassName('hintProjet')[0]
            client_span.textContent ="Projet"
           if( !this.is_projet_client)
                client_span.textContent ="Action"
            this.is_projet_client = !this.is_projet_client;
        },
        nouveau() {
            window.location.href = "/#/admin/action";
            location.reload();
        },
        Update_projet(numAction, save=0) {
            var self=this;
                $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update_projet': 1,
                    'num_action':numAction,
                    'NATURE':self.nature,
                    'ACTIVITE':self.activite,
                    'INTERET':self.interet,
                    'STATUT':self.statut,
                    'ORIGINE':self.origine,
                    'NUM_DEV':self.devis,
                    'NUM_AFFAIR':self.affaire,
                    'RESSOURCE':self.technicien,
                    'PRESTATAIRE':self.prestataire
                    },
                    dataType: "html",
                    success: function(data) {
                        if(save)
                        document.location.href=window.location.href +'?num_act='+numAction;
                        
                        location.reload();
                    }
                });
        },
        beforeAvatarUpload(file) {
            this.theBlob = file;
        },
        deleteRow(index,rows){
          rows.splice(index,1);
        },
        handlePreview(file) {
            if (file.name.toLowerCase().includes('jpg') || file.name.toLowerCase().includes('png') || file.name
                .toLowerCase().includes('jpeg')) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
            return true
        },
        isImage(file) {
            return (file.toLowerCase().includes('jpg') || file.toLowerCase().includes('png') || file
                .toLowerCase().includes('jpeg'))
        },
        handleRemove(file) {
            var vm = this;
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                        'remove_img': 1,
                        'action': vm.numAct,
                        'name': file.name,
                        'image_id': file.image_id
                },
                dataType: "multipart/form-data",
                success: function(data) {
                    console.log('update fini');
                }
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleDownload(file) {
        },
        handleDoublon(file) {
            this.beforeAvatarUpload()
            return true;
        },

        handleSuccess(file, fileD) {


            console.log(file)
            var imageUrl =  URL.createObjectURL(file.raw);
                        this.fileList.push({
                            'name': file.name,
                            'url': imageUrl
                        })
            console.log(imageUrl)


    var vm = this;
    this.toDataURL(file.url, function(dataUrl) {
    console.log('RESULT:', dataUrl)
    var request = $.ajax({
        url: BACKEND_URL+"controller/action.php",
        async: false,
        type: "POST",
        data: {
                'download': 1,
                'name': file.name,
                'file': dataUrl,
                'action': vm.numAct,
        },
        dataType: "multipart/form-data",
        success: function(data) {
            console.log('update fini');
        }
    });

})

            return true;
        },
        toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
              callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        },
        removeImg(file) {
            this.$confirm('Confirmez vous la suppression?', 'Suppression', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                type: 'warning'
            }).then(() => {
                var index = this.fileList.findIndex(x => x.uid === file.uid);
                if (index > -1) {
                    this.fileList.splice(index, 1);
                    var request = $.ajax({
                        url: BACKEND_URL+"controller/action.php",
                        async: false,
                        type: "POST",
                        data: {
                            'remove_img': 1,
                            'name': file.name,
                            'action': this.numAct
                        },
                        dataType: "html",
                        success: function(data) {
                            console.log('update fini');
                        }
                    });
                }
            });


        },




        afficheTache() {

        const res= this.listeTacheComplete.map((e)=>{
                 return e.TACHE

            })
           return res
        },

    

        rowClikedListeTache(row){
       this.texteObs= row.TEXTE
       this.RANGCourant=row.RANG
        },
        //---------------------
        handleRadioValider() {

            if (this.rencontre == 1) {
                this.rencontre = 0;
            } else {
                this.rencontre = 1;
            }
            if (this.rencontre == 1) {
                $(event.currentTarget).addClass('BtnValiderDevisPlain');
                $(event.currentTarget).removeClass('BtnValiderDevisNPlain');

                $(event.currentTarget).siblings().first().removeClass('BtnRefuserDevisPlain');
                $(event.currentTarget).siblings().first().addClass('BtnRefuserDevisNPlain');
            } else if (this.rencontre == 0) {
                $(event.currentTarget).removeClass('BtnValiderDevisPlain');
                $(event.currentTarget).addClass('BtnValiderDevisNPlain');

                $(event.currentTarget).siblings().first().removeClass('BtnRefuserDevisPlain');
                $(event.currentTarget).siblings().first().addClass('BtnRefuserDevisNPlain');
            }
        },
        handleRadioRefuser() {
            if (this.rencontre == 2) {
                this.rencontre = 0;
            } else {
                this.rencontre = 2;
            }
            if (this.rencontre == 2) {
                $(event.currentTarget).addClass('BtnRefuserDevisPlain');
                $(event.currentTarget).removeClass('BtnRefuserDevisNPlain');

                $(event.currentTarget).siblings().first().removeClass('btnValiderDevisTab');
                $(event.currentTarget).siblings().first().addClass('BtnValiderDevisNPlain');
            } else if (this.rencontre == 0) {
                $(event.currentTarget).removeClass('BtnRefuserDevisPlain');
                $(event.currentTarget).addClass('BtnRefuserDevisNPlain');

                $(event.currentTarget).siblings().first().removeClass('btnValiderDevisTab');
                $(event.currentTarget).siblings().first().addClass('BtnValiderDevisNPlain');
            }
        },
        handleRencontre(index, numCont, typeCont, tiersCont, numAct) {
            var rencontre = 0;
            if (event.currentTarget.checked) {
                rencontre = 1;
            }
            var seld=this
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'rencontre': rencontre,
                    'numCont': numCont,
                    'typeCont': typeCont,
                    'tiersCont': tiersCont,
                    'numAct': numAct,
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');   
                }
            });
        },
        handleDtePrev() {


            if (this.dte_prev === null) {
                this.dte_prev = '';
            }
            if (this.etat=='En cours') {
             var date_prev = moment(this.dte_prev, "DD-MM-yyyy HH:mm").format("YYYY-MM-DD HH:mm");
             var date_prevD = moment(this.dte_prevD, "DD-MM-yyyy HH:mm").format("YYYY-MM-DD HH:mm");
             var date_prevF = moment(this.dte_prevF, "DD-MM-yyyy HH:mm").format("YYYY-MM-DD HH:mm");

                 console.log('date_prev   handleDtePrev')
                 console.log(date_prev)
                 
                 console.log('dte_prevF   handleDtePrev')
                 console.log(date_prevF)
                 var seld=this

               
                 //console.log(this.dte_prev)
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_prev':date_prev.replace(" ", "T")+':00', 
                    'dte_prevF':date_prevF.replace(" ", "T")+':00',
                    'HRE_DEB_PREV':this.dte_prevD,
                    'HRE_FIN_PREV':this.dte_prevF,
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update datz fini'+data);   
                }
            });
            }
        },
         handleFrequence(num_act){
           //  console.log("update objet")
          
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'handleFrequence': 1,
                    'numAct':this.numAct,
                    'detail_freq':this.detail_freq 
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                   
                   // location.reload();
                }
            });

        },
        // *********************************************************************************************************/
        handleDteReal() {
            var seld=this

            if (this.dte_real === null) {
                this.dte_real = '';
            }
                   var date_real = moment(this.dte_real, "DD-MM-yyyy HH:mm").format(
               "YYYY-MM-DD HH:mm");

                 var date_realF = moment(this.dte_realF, "DD-MM-yyyy HH:mm").format(
              "YYYY-MM-DD HH:mm");
                 console.log('date_real dans handleDteReal')
                 console.log(this.dte_real)
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_real': date_real.replace(" ", "T")+':00',
                    'dte_realF':date_realF.replace(" ", "T")+':00',
                    'insertH':seld.insertH
                },
                dataType: "html",
            });
        },

        handleNUM_AFFAIRE() {
            var seld=this
            if (this.NUM_AFFAIRE === null) {
                this.NUM_AFFAIRE = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'NUM_AFFAIRE': this.NUM_AFFAIRE,
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                }
            });
        },

        handleEstime() {
            var seld=this
            if (this.echeance === null) {
                this.echeance = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'updateEcheance': 1,
                    'numAct': seld.numAct,
                    'echeance': seld.echeance,
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    console.log(seld.echeance);
                }
            });
        },

        handleMontant() {
            var seld=this
            if (this.montant === null) {
                this.montant = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {

                    'updateMontant': 1,
                    'numAct': seld.numAct,
                    'montant': parseFloat(seld.montant),
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    console.log(seld.montant);
                }
            });
        },


        handleQuantite() {
            var seld=this
            if (this.quantite === null) {
                this.quantite = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {

                    'updateQuantite': 1,
                    'numAct': seld.numAct,
                    'quantite': parseFloat(seld.quantite),
                    'insertH':seld.insertH
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    console.log(seld.quantite);
                }
            });
        },


        getCDE_TABLEFromLIB(liste, lib_50) {
            //debugger;
            for (var i = 0; i < liste.length; i++) {
                if (liste[i].LIB_50 == lib_50) {
                    return liste[i].CDE_TABLE;
                }
            }
            return '';
        },


        handleSelectChange(champ) {
            var lib_50 = event.currentTarget.textContent;
            var seld=this

            // UPDATE DU CHAMP NATURE DANS LA TABLE ACTIONCRM
            if (champ == 'NATURE') {
                var cde_table = this.getCDE_TABLEFromLIB(this.optionsNature, lib_50);

                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'nature': cde_table,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                    }

                });
            }
            // Gestion de l'origine
            else if (champ == 'ORIGINE') {
                var cde_table = this.getCDE_TABLEFromLIB(this.optionsOrigine, lib_50);

                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'origine':cde_table,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                    }

                });
            }
            // Gestion de l'interet
            else if (champ == 'INTERET') {
                var cde_table = this.getCDE_TABLEFromLIB(this.optionsInteret, lib_50);

                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'interet': cde_table,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                    }

                });
            }
            // Gestion de l'interet
            else if (champ == 'STATUT') {
                var cde_table = this.getCDE_TABLEFromLIB(this.optionsStatut, lib_50);

                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'statut': cde_table,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                        console.log(cde_table);
                    }
                });
            }

            else if (champ == 'DEVIS') {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'devis': seld.devis,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                        console.log(seld.devis);
                    }
                });
            }

            else if (champ == 'AFFAIRE') {
                const affdata = this.optionsAffaire.filter(row => row.NUM_AFFAIRE == seld.affaire)[0]
                this.conducteur= affdata.COND_TRAV
                this.siteAff= affdata.SITE_EXECUTION
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'affaire': seld.affaire,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                        console.log(seld.affaire);
                    }
                });
            }
            
        },
        handleSelectChangeTache(champ, rang) {
            var lib_50 = event.currentTarget.textContent;
            var seld=this
            if(champ =='activite'){
                $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': seld.numAct,
                        'activite': seld.activite,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                    }

                });
            }
            if (champ == 'RESSOURCE') {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': seld.numAct,
                        'ressource': lib_50,
                        'rang': rang,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        
                    }

                });
            }
        },
         handleTextarea(texte){
           var seld=this
                
                var textPrep = decodeURI(this.$refs.commentPrep.value)
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct':this.numAct,
                        'preparation': textPrep,//.replace(/<\/?[^>]+(>|$)/g, ""),
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });

                var textCompteRend = encodeURI(this.$refs.commentCompteRend.value)
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'compte_rendu': textCompteRend,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
         },
     /******************************************************************** */  
        handleTextareaTache(texte, rang) {
            var seld=this

            if (texte == 0) {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'tache': event.currentTarget.value,
                        'rang': this.RANGCourant,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
            } else if (texte == 1) {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'observation': event.currentTarget.value,
                        'rang': this.RANGCourant,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
            }
        },
   /***************************************************************************** */
        handleDtePrev_tache(rang, index) {
            var seld=this
            if (this.taches_PRE.taches_PRE_ID[index] === null) {
                this.taches_PRE.taches_PRE_ID[index] = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_prev_tache': this.taches_PRE.taches_PRE_ID[index],
                    'rang': rang,
                    'insertH':seld.insertH
                },
                dataType: "html",
            });
        },

        handleDteReal_tache(rang, index) {
            var seld=this
            if (this.taches_REA.taches_REA_ID[index] === null) {
                this.taches_REA.taches_REA_ID[index] = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_real_tache': this.taches_REA.taches_REA_ID[index],
                    'rang': rang,
                    'insertH':seld.insertH
                },
                dataType: "html",
            });
        },

        handleClose() {
            this.dialogTache.intervenant = '';
            this.dialogTache.tache = '';
            this.dialogTache.date_prev = new Date();
            this.dialogTache.date_real = '';
            this.dialogTache.observation = '';
        },
        verifChampsTache() {
            var complet = 0;
            if ($('#dialogIntervenant').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir un intervenant', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogTache').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir une tâche', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogDate_prev').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir une date prévue', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            }
            return complet;
        },
        handleEnregistrementTache() {
            var complet = this.verifChampsTache();
            if (complet == 0) {
                var temp = this;

          var date_prev = moment(document.getElementById('dialogDate_prev').value, "dd-MM-yyyy HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
          var date_real = moment(document.getElementById('dialogDate_real').value, "dd-MM-yyyy HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'insertTache': 1,
                        'numAct': this.numAct,
                        'intervenant': $('#dialogIntervenant').val(),
                        'tache': $('#dialogTache').val(),
                        'date_prev': $('#dialogDate_prev').val(),
                        'date_real': $('#dialogDate_real').val(),
                        'observation': $('#dialogObservation').val()
                    },
                    dataType: "json",
                    success: function(data) {
                        temp.dialogFormTacheVisible = false;
                        temp.listeTaches = data;
                        temp.remplirVmodel();
                        temp.select = ''
                    }
                });
            }
            location.reload();
        },

        handleClose1() {
            this.dialogInterlocuteur.civilite = '1';
            this.dialogInterlocuteur.prenom = '';
            this.dialogInterlocuteur.nom = '';
            this.dialogInterlocuteur.fonction = '';
            this.dialogInterlocuteur.telFixe = '';
            this.dialogInterlocuteur.telPortable = '';
            this.dialogInterlocuteur.email = '';
            this.dialogInterlocuteur.adr0 = '';
            this.dialogInterlocuteur.adr1 = '';
            this.dialogInterlocuteur.adr2 = '';
            this.dialogInterlocuteur.adr3 = '';
            this.dialogInterlocuteur.cp = '';
            this.dialogInterlocuteur.pays = '';
            this.dialogInterlocuteur.internet = '';
            this.dialogInterlocuteur.fax = '';
            this.dialogInterlocuteur.type = '';
            this.dialogInterlocuteur.inactif = '';
            this.dialogInterlocuteur.date_creat = '';
            this.dialogInterlocuteur.date_MAJ = '';
        },
        verifChampsInterlocuteur() {
            var complet = 0;
            if ($('#dialogPrenom').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir un prénom', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogNom').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir un nom', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogFonction').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir une fonction', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            }
            return complet;
        },

        handleAjouterInterlocuteurCollapse() {
            this.dialogFormInterlocuteurVisible = !this.dialogFormInterlocuteurVisible;
            this.handleAjouterInterlocuteurVisible =!this.dialogFormInterlocuteurVisible;
        },
        handleAjouterInterlocuteur() {
            this.handleAjouterInterlocuteurCollapse()
            var complet = this.verifChampsInterlocuteur();
            if (complet == 0) {
                this.$alert(
                    'Interlocuteur bien ajouté à la liste. Veuillez recharger la page pour pouvoir ajouter cet interlocuteur à l\'action',
                    'Erreur', {
                        confirmButtonText: 'OK'
                    });

                var temp = this;
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'insertInterlocuteur': 1,
                        'type': $('#dialogType').val(),
                        'tiersCont': this.listeInterlocteursPotentiels[0].TIERS,
                        'nom': $('#dialogNom').val(),
                        'fonction': $('#dialogFonction').val(),
                        'telFixe': $('#dialogTelFixe').val(),
                        'telPortable': $('#dialogTelPortable').val(),
                        'fax': $('#dialogFax').val(),
                        'email': $('#dialogEmail').val(),
                        'adr0': $('#dialogAdr0').val(),
                        'adr1': $('#dialogAdr1').val(),
                        'adr2': $('#dialogAdr2').val(),
                        'adr3': $('#dialogAdr3').val(),
                        'cp': $('#dialogCP').val(),
                        'pays': $('#dialogPays').val(),
                        'civilite': this.dialogInterlocuteur.civilite,
                        'prenom': $('#dialogPrenom').val(),
                        'date_creat': $('#dialogDate_creat').val(),
                        'date_MAJ': $('#dialogDate_MAJ').val(),
                        'inactif': $('#dialogInactif').val(),
                        'internet': this.dialogInterlocuteur.internet,
                        'numAct': temp.numAct,
                        'tiers': temp.action['CDE_CLI']
                    },
                    dataType: "json",
                    success: function(data) {

                    temp.listeInterlocteursPotentiels = data;

                    }
                });
            }
        },

        handleRetirerInterlocuteur(num_contac) {
             var self=this
             var numContact=num_contac
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'removeInterlocuteur': 1,
                    'numAct': this.numAct,
                    'num_contac': num_contac
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    self.listeInterlocteurs= self.listeInterlocteurs.filter(data2 => 
                       !data2.NUM_CONTAC.includes(numContact))
                }
            });
        },

        handleSupprimerTache(rang) {
            var rangTemp=rang
            var self=this
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'deleteTache': 1,
                    'numAct': this.numAct,
                    'rang': rang
                },
                dataType: "html",
                success: function(data) {

                    self.listeTaches= self.listeTaches.filter(data3 => 
                        !data3.RANG.includes(rangTemp))
                  

                 
                    }
                })
            
        },
        handleUpdateObjet(){
            var seld=this
            if(this.insertH==1) this.verifier_champs();
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'updateObjet': 1,
                    'numAct':this.numAct,
                    'objet':this.objet,
                    'insertH':seld.insertH 
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    //location.reload();
                }
            });

        },
        
        // --------------------------------------------------------------------------
        // ----------------------------------------------------------------------------------
        //-------------------------------------------------------------------------------------------------------------

        handleModifieTache(numACT,rang,DTE_REAL2) {
           // console.log("handleModifieTache")
           var seld=this
 
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': numACT,
                    'rang': rang,
                    'dte_real_tache':DTE_REAL2,
                    'insertH':seld.insertH
                    // 'ind':this.index
                },
                dataType: "html",
                success: function(data) {
                    console.log(' le row pour Date de realisation à jour ');

                }
            });
        },

           newDateRealiz(){
            this.sidebarStore.showSidebar=true
                for (var i = 0; i < this.listeTaches.length; i++) {
                    if ((this.listeTaches[i].DTE_REAL2 ==null) && (this.RANGCourant!=-1)){
                        if(this.listeTaches[i].RANG ==  this.RANGCourant){
                            this.listeTaches[i].DTE_REAL2 = moment(this.dialogTache.date_real, "yyyy-DD-MM").format(
                "DD/MM/YYYY");
                            this.handleModifieTache(this.listeTaches[i].NUM_ACTION,this.listeTaches[i].RANG,this.listeTaches[i].DTE_REAL2) 
                        }
                    }
                }
                location.reload()
        },

        // --------------------------------------------------

        recupInterlocuteursPotentiels() {
           this.dialogFormInterlocuteurVisible = true;
            var temp = this;
            console.log('temp.action')
          console.log(temp.action)
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                
                data: {
                    'recupListeInterlocuteurs': 1,
                    'numAct': temp.numAct,
                    'tiers': temp.action['CDE_CLI']

                },
                dataType: "json",
                success: function(data) {
                    temp.listeInterlocteursPotentiels = data;
                }
                      });
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleEnregistrementInterlocuteurs() {
            if (this.multipleSelection.length > 0) {
                var temp = this;
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'ajouterInterlocuteurs': 1,
                        'numAct': this.numAct,
                        'listeInterlocteurs': this.multipleSelection
                    },
                    dataType: "json",
                    success: function(data) {
                        temp.dialogFormInterlocuteurVisible = false;
                        temp.listeInterlocteurs = data;
                        temp.remplirVmodel();
                    }
                });
            }
        },

        remplirVmodel() {
            for (var i = 0; i < this.listeInterlocteurs.length; i++) {
                this.interlocuteurs.interlocuteurs_ID[i] = !!parseInt(this.listeInterlocteurs[i].VU);
            }
            for (var i = 0; i < this.listeTaches.length; i++) {
                this.taches_LIB.taches_LIB_ID[i] = this.listeTaches[i].TACHE;
            }
            for (var i = 0; i < this.listeTaches.length; i++) {
                this.taches_OBS.taches_OBS_ID[i] = this.listeTaches[i].TEXTE;
            }
            for (var i = 0; i < this.listeTaches.length; i++) {
                this.taches_INT.taches_INT_ID[i] = this.listeTaches[i].RESSOURCE;
            }
            for (var i = 0; i < this.listeTaches.length; i++) {
                this.taches_PRE.taches_PRE_ID[i] = this.listeTaches[i].DTE_PREV;
            }
            for (var i = 0; i < this.listeTaches.length; i++) {
                this.taches_REA.taches_REA_ID[i] = this.listeTaches[i].DTE_REAL;
            }
        },
        handleUpdateDEVIS(){
            var NUM_DEV=this.NUM_DEV
                    for (var j = 0; j < this.action.DEVIS.length; j++) {
                        if (NUM_DEV == this.action.DEVIS[j].NUM_DEV && this.action.DEVIS[j].montant!=null) {
                            this.montant = this.action.DEVIS[j].montant
                        }
                    }
        },
     
        handleRapport () {
            var request = $.ajax({
                url: BACKEND_URL+"controller/generepdf.php",
                async: false,
                type: "POST",
                data: {
                    'rapport_action': 1,
                    'numAct':this.numAct,
                    'listeInterlocteurs':this.listeInterlocteurs
                },
                dataType: "html",
                success: function(data) {
                    console.log(data);
                var dataParsed = JSON.parse(data)
                var element = document.createElement('a');
                element.setAttribute('href',  dataParsed.file);
                element.setAttribute('download', dataParsed.name);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);

                }
            });
        },

           handleUpdateEtat(){

            if (this.etat=='En cours') {
              if(this.dte_real == null || this.dte_real == ''){
                alert('Veuillez précisez une date de réalisation') 
                document.getElementById('detail_dte_real').focus() 
                return
                }
                if(this.dte_clot == null || this.dte_clot == '')
                {
                    this.dte_clot=moment(new Date(), "DD-MM-yyyy").format("DD-MM-yyyy");
                }
            var r = confirm("Veuillez confirmer la clôture de l'action ");
                if (r == true) {
                var seld=this

                var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'updateEtat': 1,
                    'numAct':this.numAct,
                    'etat':'CL',
                    'DTE_CLOT':this.dte_clot,
                    'DTE_REAL':this.dte_real,
                    'HRE_DEB_REAL':this.dte_prevD,
                    'HRE_FIN_REAL':this.dte_prevD,
                    'CDE_CLI':this.cde_cli,
                    'insertH':seld.insertH
                },
                dataType: "html",
                    success: function(data) {
                   
                    //console.log(data)
                    location.reload();
                    }
                }
                
                
            );}
            } 
            
            if (this.etat=='Cloturé') {
            var r = confirm("Veuillez confirmer la déclôture de l'action ");
                if (r == true) {
                var seld=this

                var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'updateEtat': 1,
                    'numAct':this.numAct,
                    'etat':'EC',
                    'insertH':seld.insertH
                },
                dataType: "html",
                    success: function(data) {
                   
                    //console.log(data)
                    location.reload();
                    }
                }
                
                
            );}
            }  
            
        },

           handleUpdatePriorite(){
            if(this.insertH==1) this.verifier_champs();
            var seld=this
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'updatePriorite': 1,
                    'numAct':this.numAct,
                    'priorite':this.priorite,
                    'insertH':seld.insertH 
                },
                dataType: "html",
                success: function(data) {
                    console.log('update fini');
                    //location.reload();
                }
            });

        },
    
    },
    mounted() {

        this.remplirVmodel();
        this.reactiviteDetail = true;
        
      },
      beforeRouteUpdate(to, from, next) {
        if (typeof to.query.new != 'undefined' && to.name =="Action") {
            window.location.href = "/#/admin/action";
            location.reload();
        };
      }
    }
  
</script>
<style>
.ck-content { height:400px; }
.ColonneGauche{
    
    font-weight: bold !important;
    font-size: 12px !important;
    font-family: verdana;
    margin-left:10px;
}
legend {
    border: 1px solid black;
    font-size: 20px;
    text-align: left;
    width: 95%;
    margin-left: 20px;
    background-color: #33434a;
    color: #fff;
    padding: 1px 3px;
}
fieldset{
    width: 40%;
    border: 1px solid black;
}
.output {
    font: 1rem 'Fira Sans', sans-serif;
}

input {
    margin: .4rem;
}
.fixed_buttons{
    position: fixed;
    top: 10px;
    right: 11px;
    z-index: 15;
}

label abbr {
  color: red;
}

@media all and (max-width: 800px) {
    fieldset{
    width: 97%;
    }
}
@media all and (max-width: 1300px) and (min-width: 1000px) {
    fieldset{
    width: 60%;
    }
}
@media all and (max-width: 1000px) and (min-width: 800px) {
    fieldset{
    width: 85%;
    }
}
</style>